export default __webpack_public_path__ + "static/media/websiteIcon.549318f5.svg";